import React from "react";
import { useSelector } from "react-redux";
import { Bar } from "react-chartjs-2";
import { ChartData } from "chart.js";
import { useTranslation } from "react-i18next";

import { verticalChartOptions } from "../../../../../utils/charts/chartOptions";
import ChartLegend from "../../ChartLegend/ChartLegend";
import { RootState } from "../../../../../store/store";
import theme from "../../../../../components/styles/theme/theme";

const EconomicBeneficiaryChart: React.FC = () => {
  const { t } = useTranslation();

  const {
    statistics: { statisticsForSelectedCountry },
  } = useSelector((state: RootState) => state);

  const statisticsDataArray = [
    [
      statisticsForSelectedCountry &&
        statisticsForSelectedCountry.va_byBeneficiary
          .salaries_theCocaColaSystem,
      statisticsForSelectedCountry &&
        statisticsForSelectedCountry.va_byBeneficiary.profits_TheCocaColaSystem,
      statisticsForSelectedCountry &&
        statisticsForSelectedCountry.va_byBeneficiary.taxes_theCocaColaSytem,
    ],
    [
      statisticsForSelectedCountry &&
        statisticsForSelectedCountry.va_byBeneficiary
          .salaries_suppliers_and_outlets,
      statisticsForSelectedCountry &&
        statisticsForSelectedCountry.va_byBeneficiary
          .profits_suppliers_and_outlets,
      statisticsForSelectedCountry &&
        statisticsForSelectedCountry.va_byBeneficiary
          .taxes_suppliers_and_outlets,
    ],
    [
      statisticsForSelectedCountry &&
        statisticsForSelectedCountry.va_byBeneficiary
          .salaries_suppliers_and_outlets_suppliers,
      statisticsForSelectedCountry &&
        statisticsForSelectedCountry.va_byBeneficiary
          .profits_suppliers_and_outlets_suppliers,
      statisticsForSelectedCountry &&
        statisticsForSelectedCountry.va_byBeneficiary
          .taxes_suppliers_and_outlets_suppliers,
    ],
  ].map((row) => row.map((value) => (value === 0 ? null : value)));

  const labels = [
    t("charts.salaries_label"),
    t("charts.profits_label"),
    t("charts.taxes_label"),
  ];
// @ts-ignore
  const data: ChartData<"bar"> = {
    labels,
    datasets: [
      {
        label: t("charts.system_label") || "",
        data: statisticsDataArray[0],
        backgroundColor: theme.palette.secondary["600"],
        minBarLength: 20,
        maxBarThickness: 80,
        borderWidth: 1,
        borderColor: theme.palette.common.white,
      },
      {
        label: t("charts.first_tier_suppliers_and_outlets_label") || "",
        data: statisticsDataArray[1],
        backgroundColor: theme.palette.secondary["200"],
        minBarLength: 20,
        maxBarThickness: 80,
        borderWidth: 1,
        borderColor: theme.palette.common.white,
      },
      {
        label: t("charts.suppliers_of_suppliers_and_outlets_label") || "",
        data: statisticsDataArray[2],
        backgroundColor: theme.palette.secondary["50"],
        minBarLength: 20,
        maxBarThickness: 80,
        borderWidth: 1,
        borderColor: theme.palette.common.white,
      },
    ],
  };

  return (
    <>
      <Bar options={verticalChartOptions("economic_value_added")} data={data} />
      <ChartLegend data={data} />
    </>
  );
};

export default EconomicBeneficiaryChart;
